<template>
	<div class="quiz-results">
		<p class="quiz-results__hint">Ваш результат</p>
		<QuizResultCard
			v-for="(result, key) in props.results"
			:id="props.id"
			:key="key"
			:result="result"
			:placement="props.placement"
		/>
	</div>
</template>

<script setup lang="ts">
import QuizResultCard from './quiz-result-card.vue';

interface Props {
	id: string;
	placement: string;
	results: QuizResult[];
}

const props = defineProps<Props>();
</script>